<template>
  <div id="ThreeTopRightContent">
    <c-block-box title="用户运营" class="first-floor-item-1">
      <div class="content-wrap">
        <div class="item-wrap">
          <p class="hd-title">付费用户增长曲线 </p>
          <div class="item1-content">
            <DomeEchartWrap ref="GrowthCurvePayingUsers" id="GrowthCurvePayingUsers"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-wrap">
          <p class="hd-title">用户留存及付费指数 </p>
          <div class="item2-content">
            <DomeEchartWrap ref="UserRetentionPaymentIndex" id="UserRetentionPaymentIndex"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-wrap">
          <p class="hd-title">用户付费分布 </p>
          <div class="item3-content">
            <div class="percent-wrap">
              <div class="item" v-for="item in UserPaymentDistributionLists">
                <div class="name">{{ item.name }}</div>
                <div class="rate">{{ item.rate }}<span class="dw">万</span></div>
              </div>
            </div>
            <DomeEchartWrap ref="UserPaymentDistribution" id="UserPaymentDistribution"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-wrap">
          <p class="hd-title">日均开机时长（分钟）  </p>
          <div class="item4-content">
            <DomeEchartWrap ref="AverageDailyStartupTime" id="AverageDailyStartupTime"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-wrap item5-wrap">
          <p class="hd-title">成熟期用户典型特征</p>
          <div class="item5-content">
            <DomeEchartWrap ref="TypicalCharacteristicsMatureUsers" id="TypicalCharacteristicsMatureUsers"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-wrap">
          <p class="hd-title">用户标签云</p>
          <div class="item6-content">
            <DomeEchartWrap ref="UserTagCloud" id="UserTagCloud"></DomeEchartWrap>
          </div>
        </div>
      </div>
    </c-block-box>
  </div>
</template>

<script>
import common from '@/mixins/common.js'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import { UserTagCloudEchartOp, TypicalCharacteristicsMatureUsersEchartOp, AverageDailyStartupTimeEchartOp, GrowthCurvePayingUsersEchartOp, UserRetentionPaymentIndexEchartOp, UserPaymentDistributionEchartOp } from './js/ThreeFloorItem2'

export default {
  mixins: [common],
  name: 'ThreeTopRightContent',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      UserPaymentDistributionLists: []
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.$refs['TypicalCharacteristicsMatureUsers'].setEchartOption(TypicalCharacteristicsMatureUsersEchartOp({ v: this }))
  },
  watch: {
    data: {
      deep: true,
      handler: function (newValue, oldValue) {
        let { payUserChartVOList, timeCountList, userChartMapList, userPayTotalTop, userTag } = newValue ?? {}
        this.$nextTick(() => {
          this.payUserChartVOList(payUserChartVOList)
          this.userChartMapList(userChartMapList)
          this.userTag(userTag)
          this.userPayTotalTop(userPayTotalTop)
          this.timeCountList(timeCountList)
        })
      }
    }
  },
  methods: {
    payUserChartVOList (val) { // 付费用户增长曲线
      if (!val) { return }
      let date = []
      let data = {
        totalVip: [],
        vaildVipRate: []
      }
      let dateLists = Object.keys(val)
      dateLists.sort((a, b) => {
        return this.$dayjs(a).isBefore(this.$dayjs(b)) ? -1 : 1
      })
      // console.log(this.$dayjs('2021-01').isBefore(this.$dayjs('2021-06')))
      dateLists.forEach(item => {
        date.push(item.slice(5))
        data.totalVip.push(val[item].totalVip)
        data.vaildVipRate.push(val[item].vaildVipRate)
      })
      this.$refs['GrowthCurvePayingUsers'].setEchartOption(GrowthCurvePayingUsersEchartOp({ v: this,
        data: {
          date, data
        } }))
    },
    userChartMapList (val) { // 用户留存
      if (!val) { return }
      let date = []
      let data = []
      val.forEach(item => {
        date.push(item.month.slice(5))
        data.push(item.reteniton)
      })
      this.$refs['UserRetentionPaymentIndex'].setEchartOption(UserRetentionPaymentIndexEchartOp({ v: this,
        data: {
          date, data
        } }))
    },
    userTag (val) {
      if (!val) { return }
      let data = []
      data = val.map(item => {
        return {
          name: item.tag,
          value: item.cnt
        }
      })
      this.$refs['UserTagCloud'].setEchartOption(UserTagCloudEchartOp({ v: this, data }))
    },
    userPayTotalTop (val) {
      if (!val) { return }
      let name = []
      let data = []
      let max = 0
      val.forEach(item => {
        name.unshift(item.productType)
        data.unshift(item.total)
        this.UserPaymentDistributionLists.push({
          name: item.productType,
          rate: 0
        })
      })
      max = Math.max(...data) * 1.2
      this.$refs['UserPaymentDistribution'].setEchartOption(UserPaymentDistributionEchartOp({ v: this,
        data: {
          name, data, max
        } }))
    },
    timeCountList (val) {
      if (!val) { return }
      let date = []
      let data = []
      val.forEach(item => {
        date.unshift(item.year)
        data.unshift(item.cnt)
      })
      this.$refs['AverageDailyStartupTime'].setEchartOption(AverageDailyStartupTimeEchartOp({ v: this,
        data: {
          data, date
        } }))
    }
  },
  components: {
    DomeEchartWrap
  }
}
</script>

<style scoped lang="stylus">
.content-wrap
  padding: 1.5rem 2rem
  display flex
  flex-wrap: wrap;
  justify-content: space-between
  .item-wrap
    width 17.5rem
    height 17.3rem
    display flex
    flex-direction: column
    .hd-title
      font-size: 1.3rem
      color: rgba(255, 255, 255, 0.8)
      margin-bottom: 1.5rem
    .item1-content,.item2-content,.item3-content,.item4-content,.item5-content,.item6-content
      flex-grow: 1
  .item-wrap:nth-of-type(n+4)
    margin-top: 1rem
    height 18.3rem
  .item3-content
    display: flex
    .percent-wrap
      width 4.6rem
      .item
        width 100%
      .name
        font-size: .6rem
        color rgba(255, 255, 255, 0.8)
        margin-bottom: 0.15rem
      .rate
        font-size: .9rem
        color: #fff
        margin-left: auto
        .dw
          color: #878787;
          font-size: .5rem
          margin-left: .13rem
      .item+.item
        margin-top: 1.4rem
  #UserPaymentDistribution
    flex-grow: 1
</style>
